// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 2rem 0.5rem 1rem;
    background-color: #172228;
    border-bottom: 2px solid rgba(216, 184, 161, 0.2);
    height: 60px;
    z-index: 1000;
}

.header-logo {
    display: flex;
    align-items: center;
}

.header-logo-text {
    color: #d8b8a1;
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: 1px;
}

.header-user {
    display: flex;
    align-items: center;
}

.user-info {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    padding: 0.5rem;
    border-radius: 4px;
}

.user-info:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 8px;
}

.user-name {
    margin-right: 8px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
}

.dropdown-icon {
    color: #ffffff;
    font-size: 12px;
}

.user-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    min-width: 150px;
    z-index: 1000;
    margin-top: 4px;
}

.user-dropdown button {
    width: 100%;
    padding: 8px 16px;
    border: none;
    background: none;
    text-align: left;
    cursor: pointer;
    color: #111;
}

.user-dropdown button:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
    .app-header {
        padding: 0.5rem 0.5rem 0.5rem 0.5rem;
    }
    
    .user-name {
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .app-header {
        padding: 0.5rem 0.4rem;
    }
    
    .user-name {
        font-size: 14px;
    }
    
    .user-avatar {
        width: 28px;
        height: 28px;
        margin-right: 6px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/assets/styles/header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,yBAAyB;IACzB,iDAAiD;IACjD,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,oCAAoC;IACxC;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":[".app-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.5rem 2rem 0.5rem 1rem;\n    background-color: #172228;\n    border-bottom: 2px solid rgba(216, 184, 161, 0.2);\n    height: 60px;\n    z-index: 1000;\n}\n\n.header-logo {\n    display: flex;\n    align-items: center;\n}\n\n.header-logo-text {\n    color: #d8b8a1;\n    font-size: 1.5rem;\n    font-weight: 700;\n    letter-spacing: 1px;\n}\n\n.header-user {\n    display: flex;\n    align-items: center;\n}\n\n.user-info {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n    padding: 0.5rem;\n    border-radius: 4px;\n}\n\n.user-info:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n.user-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    margin-right: 8px;\n}\n\n.user-name {\n    margin-right: 8px;\n    font-weight: 500;\n    font-size: 16px;\n    color: #ffffff;\n}\n\n.dropdown-icon {\n    color: #ffffff;\n    font-size: 12px;\n}\n\n.user-dropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    background-color: #ffffff;\n    border-radius: 4px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    min-width: 150px;\n    z-index: 1000;\n    margin-top: 4px;\n}\n\n.user-dropdown button {\n    width: 100%;\n    padding: 8px 16px;\n    border: none;\n    background: none;\n    text-align: left;\n    cursor: pointer;\n    color: #111;\n}\n\n.user-dropdown button:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 768px) {\n    .app-header {\n        padding: 0.5rem 0.5rem 0.5rem 0.5rem;\n    }\n    \n    .user-name {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 480px) {\n    .app-header {\n        padding: 0.5rem 0.4rem;\n    }\n    \n    .user-name {\n        font-size: 14px;\n    }\n    \n    .user-avatar {\n        width: 28px;\n        height: 28px;\n        margin-right: 6px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
